import React from 'react';
import { Row, Col } from 'react-bootstrap';

const OfficeOwnerList = ({ owners, onEdit, ownerError }) => {
    return (
        <div className="officeOwnerContainer">
            {ownerError && <div style={{ color: 'red' }}>{ownerError}</div>}
            {owners.map((owner) => (
                <div
                    key={owner._id}
                    style={{
                        border: '1px solid gray',
                        padding: '10px',
                        marginBottom: '10px',
                    }}
                >
                    <Row>
                        <Col md="4">
                            <label>Пользователь:</label>
                            <p>{owner.userId ? `${owner.userId.firstName} ${owner.userId.lastName} (${owner.userId.email})` : 'Не указан'}</p>
                        </Col>
                        <Col md="4">
                            <label>Офисы:</label>
                            <p>
                                {owner.offices?.length > 0
                                    ? owner.offices.map((office) => office.name).join(', ')
                                    : 'Нет офисов'}
                            </p>
                        </Col>
                        <Col md="4">
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => onEdit(owner)}
                            >
                                Редактировать
                            </button>
                        </Col>
                    </Row>
                </div>
            ))}
        </div>
    );
};

export default OfficeOwnerList;